'use client';

// The canonical "live right now" indicator (BL-966) — one definition replacing
// three byte-identical copies that had drifted apart in constants/auction.tsx,
// constants/inventory.tsx, and an inline block in the inventory stat rail.
//
// Two stacked layers make the flash: an `animate-ping` halo that scales out and
// fades, over a solid core that keeps the dot visible between pulses. Decorative
// only — the adjacent status text carries the meaning, so it's aria-hidden.
//
// EMERALD, not red (Dan, 2026-09-07). BL-966 shipped it red on the argument that
// a flash should read as "attention". In practice the only thing that pulses is
// an auction on its `active` phase, whose Badge is the `success` (emerald) tone —
// so the red dot was a fourth color sitting on a green pill, saying "alert" about
// the one state that is working correctly. It also disagreed with the status
// dropdown's own trigger two inches away, which draws the tone's green dot. The
// dot now takes the tone it lives in; the FLASH still carries "right now".
//
// Use it bare (a filter-dropdown option icon, a stat chip) or via `<Badge dot
// pulse>`, which renders it in place of the static tone dot.

/**
 * A small pulsing emerald dot marking an actively-running state.
 *
 * @returns A decorative, `aria-hidden` two-layer animated dot.
 */
export default function ActiveDot() {
  return (
    <span className="relative flex h-2 w-2" aria-hidden>
      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
      <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500" />
    </span>
  );
}
